












































import Vue from 'vue';
import STooltip from '../STooltip/STooltip.vue';
import InnerButton from './Button.vue';
import getThemeTextColor from '../../utils/getThemeTextColor';

/**
 * A small, icon only button. Use the `SActionDialog` component if you want one that opens a modal.
 * Tooltips are optional but highly encouraged.
 * Use the 'toggle' prop(s) for switching between two icons, on/off
 */
export default Vue.extend({
  name: 'SAction',
  components: {
    STooltip,
    InnerButton,
  },
  props: {
    /**
     * Used to switch which icons, labels & tooltips are displayed
     */
    toggle: {
      type: Boolean,
      required: false,
    },
    /**
     * The icon to use for the component when toggle is false
     */
    icon: {
      type: String,
      required: true,
    },
    /**
     * Text to display when toggle is set to true. Turns the component into more of a button
     */
    label: {
      type: String,
      required: false,
    },
    /**
     * Text to display when toggle is false
     */
    labelAlt: {
      type: String,
      required: false,
    },
    /**
     * Color to set the icon to
     */
    iconColor: {
      type: String,
      required: false,
    },
    /**
     * Icon to use for the component when toggle is true
     */
    iconAlt: {
      type: String,
      required: false,
    },
    /**
     * The text to show in the tooltip when toggle is false
     */
    tooltip: {
      type: String,
      required: false,
    },
    /**
     * The text to show in the tooltip when toggle is set to true
     */
    tooltipAlt: {
      type: String,
      required: false,
    },
    /**
     * @see src/components/STooltip/STooltip.vue#color
     */
    tooltipColor: {
      type: String,
      default: 'primary',
    },
    /**
     * @see src/components/STooltip/STooltip.vue#simplePosition
     */
    tooltipSimple: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * The z-index of the tooltip
     */
    tooltipZIndex: {
      type: Number,
      required: false,
    },
    /**
     * Background colour of the button
     */
    buttonColor: {
      type: String,
      required: false,
    },
    smallIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    tooltipTextColor(): string {
      return getThemeTextColor(this.tooltipColor);
    },
    iconSize(): string {
      return this.smallIcon ? 'small' : 'medium';
    },
  },
});
